export const getLeaveMasterList = state => {
    return state.list
}

export const getLeaveMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveMaster/getters.js